import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { CheckCircle2 } from 'lucide-react';

export const Pavers = ({ onOpenLeadModal }) => {
  const { t } = useTranslation();

  const paverTypes = [
    'Brick Pavers',
    'Concrete Pavers',
    'Natural Stone Pavers',
    'Patio Pavers',
    'Driveway Pavers',
    'Walkway Pavers',
  ];

  const benefits = [
    'Durable and Long-Lasting',
    'Low Maintenance',
    'Versatile Design Options',
    'Increases Property Value',
    'Environmentally Friendly',
    'Easy to Repair',
  ];

  return (
    <div data-testid="pavers-page">
      {/* Hero Section */}
      <section
        className="relative py-32 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://images.pexels.com/photos/7658758/pexels-photo-7658758.jpeg)',
        }}
      >
        <div className="absolute inset-0 bg-black/50" />
        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <h1
            className="text-5xl sm:text-6xl font-bold mb-6 tracking-tight"
            style={{ fontFamily: 'Outfit' }}
          >
            Premium Brick Pavers
          </h1>
          <p className="text-xl sm:text-2xl mb-8 leading-relaxed">
            Transform your outdoor spaces with expertly installed brick pavers
          </p>
          <Button
            onClick={onOpenLeadModal}
            className="bg-white text-[hsl(215,75%,16%)] hover:bg-gray-100 px-12 py-6 text-lg rounded-md font-semibold"
            data-testid="pavers-hero-cta"
          >
            {t('hero.cta')}
          </Button>
        </div>
      </section>

      {/* Types of Pavers */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2
            className="text-4xl font-bold text-[hsl(215,75%,16%)] mb-12 text-center"
            style={{ fontFamily: 'Outfit' }}
          >
            Types of Paver Services
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {paverTypes.map((type, index) => (
              <div
                key={index}
                className="bg-[hsl(210,40%,98%)] rounded-lg p-8 text-center card-hover"
                data-testid={`paver-type-${index}`}
              >
                <h3
                  className="text-xl font-bold text-[hsl(215,75%,16%)] mb-2"
                  style={{ fontFamily: 'Outfit' }}
                >
                  {type}
                </h3>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits */}
      <section className="py-24 bg-[hsl(210,40%,98%)]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2
            className="text-4xl font-bold text-[hsl(215,75%,16%)] mb-12 text-center"
            style={{ fontFamily: 'Outfit' }}
          >
            Benefits of Brick Pavers
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {benefits.map((benefit, index) => (
              <div
                key={index}
                className="flex items-start space-x-4 bg-white rounded-lg p-6"
                data-testid={`paver-benefit-${index}`}
              >
                <CheckCircle2 className="w-6 h-6 text-[hsl(20,91%,48%)] flex-shrink-0 mt-1" />
                <p className="text-gray-700 font-medium">{benefit}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-[hsl(215,75%,16%)] text-white text-center">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2
            className="text-4xl font-bold mb-6"
            style={{ fontFamily: 'Outfit' }}
          >
            Ready to Get Started?
          </h2>
          <p className="text-xl mb-8">
            Contact us today for a free consultation and estimate
          </p>
          <Button
            onClick={onOpenLeadModal}
            className="bg-white text-[hsl(215,75%,16%)] hover:bg-gray-100 px-12 py-6 text-lg rounded-md font-semibold"
            data-testid="pavers-cta-button"
          >
            Get Free Estimate
          </Button>
        </div>
      </section>
    </div>
  );
};